__turbopack_context__.v({
  "root": "features-row-module-scss-module__vIX23W__root",
});
